import {
    PlusCircleOutlined,
} from "@ant-design/icons";
import { Button, Col, Form, Input, PageHeader, Row, Tabs, Radio } from "antd";
import "./index.scss";
import { Link } from "react-router-dom";
import { ROOT_URL } from "./../../constants/api";
import { authApis } from './../../services/authApi/index';
import { nofication } from './../../commons/Nofication';
const Register = ({
    isShowActionHeader,
    title,
    link,
    titleNew,
    isContact,
    setSearchValue,
    isMedia = false,
    ids,
    isHiddenAction = false,
    isTranslate,
    isModalVisible,
    setIsModalVisible,
    onUploadfile,
}) => {
    const download = () => {
        window.open(ROOT_URL + 'admin/exportfile?ids=' + ids, '_blank');
    };

    const exportCsv = () => {
        window.open(ROOT_URL + 'admin/export-csv', '_blank');
    };

    const uploadCsv = (e) => {
        const formData = new FormData();
        formData.append('file', e.target.files[0]);
        authApis
            .importlang(formData)
            .then((data) => {
                nofication("success", "Thành công!", "Upload thành công!");
                location.reload();
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Upload thất bại!");
            });
    };

    // const uploadFileMedia = (e) => {
    //     const formData = new FormData();
    //     formData.append('file', e.target.files[0]);
    //     authApis
    //         .importlang(formData)
    //         .then((data) => {
    //             nofication("success", "Thành công!", "Upload thành công!");
    //             location.reload();
    //         })
    //         .catch((errors) => {
    //             nofication("error", "Thất bại", "Upload thất bại!");
    //         });
    // }

    return (
        <Row>
            <Col span={24}>
                <PageHeader
                    className="header"
                    ghost={false}
                    title={titleNew ? titleNew : title}
                    extra={[
                        <>
                            <img src="/icon/home.svg" className="menu-img" />
                            {/* <Link to="/dashboard" style={{ color: "black" }}>

                            </Link> */}
                            <span>Home</span>
                            <span>/</span>
                            {/* <Link to={`${link}list`} style={{ color: "black" }}>
                                <span>{title}</span>
                            </Link> */}
                            <span>{title}</span>
                        </>,
                    ]}
                >
                    {isShowActionHeader ? (
                        <Row justify="space-between">
                            <Col span={isMedia ? 12 : 0}>
                                <Row justify="start">
                                    {isMedia ? (
                                        <>
                                            <Button
                                                size={'medium'}
                                                icon={
                                                    <img src="/icon/folder.svg" style={{ width: 17, height: 17, marginRight: 6 }} />
                                                }
                                                style={{
                                                    color: "white",
                                                    background: "#209d20",
                                                    border: "black",
                                                    fontSize: 15,
                                                    borderRadius: 7,
                                                    marginRight: 10,
                                                }}
                                                onClick={() => setIsModalVisible(!isModalVisible)}
                                            >
                                                New Folder
                                            </Button>
                                            <Button
                                                className='btn-hi'
                                                icon={<img src="/icon/upload.svg" style={{ width: 15, height: 15, marginRight: 6 }} />}
                                                size={'medium'}
                                                style={{
                                                    color: "white",
                                                    background: "#1b6ce5",
                                                    border: "black",
                                                    fontSize: 15,
                                                    borderRadius: 7,
                                                    marginRight: 10,
                                                }}
                                            >
                                                <label for="file" htmlFor="filePickeredia" >Upload a file</label>
                                            </Button>
                                            <input type="file" name="filess" multiple onChange={onUploadfile} style={{ visibility: "hidden" }} id="filePickeredia" />
                                            {/* <Radio.Group size="medium">
                                                <Radio.Button value="large" className='btn-group'>Move</Radio.Button>
                                                <Radio.Button value="default" className='btn-group'>Delete</Radio.Button>
                                            </Radio.Group> */}
                                        </>
                                    ) : (
                                        <>
                                        </>
                                    )}
                                </Row>
                            </Col>
                            <Col span={isTranslate ? 12 : 0}>
                                <Row justify="start">
                                    {isTranslate ? (
                                        <>
                                            <Button
                                                icon={<img src="/icon/upload.svg" style={{ width: 15, height: 15, marginRight: 6, transform: 'rotate(180deg)' }} />}
                                                size={'medium'}
                                                onClick={exportCsv}
                                                style={{
                                                    color: "white",
                                                    background: "#377A47",
                                                    border: "black",
                                                    fontSize: 13,
                                                    borderRadius: 7,
                                                    marginRight: 10,
                                                }}
                                            >
                                                Export
                                            </Button>
                                            <Button
                                                className='btn-hi'
                                                icon={<img src="/icon/upload.svg" style={{ width: 15, height: 15, marginRight: 6, fontSize: 12 }} />}
                                                size={'medium'}
                                                style={{
                                                    color: "white",
                                                    background: "#1b6ce5",
                                                    border: "black",
                                                    fontSize: 13,
                                                    borderRadius: 7,
                                                    marginRight: 10,
                                                }}
                                            >
                                                <label for="file" htmlFor="filePicker" >Import</label>
                                            </Button>
                                            <input type="file" name="files" multiple onChange={uploadCsv} style={{ visibility: "hidden" }} id="filePicker" accept="csv" />
                                            {/* <Radio.Group size="medium">
                                                <Radio.Button value="large" className='btn-group'>Move</Radio.Button>
                                                <Radio.Button value="default" className='btn-group'>Delete</Radio.Button>
                                            </Radio.Group> */}
                                        </>
                                    ) : (
                                        <>
                                        </>
                                    )}
                                </Row>
                            </Col>
                            <Col span={isContact ? 12 : 0}>
                                <Row justify="start">
                                    {/* <img style={{height: 32}} src="/icon/downloadexcel.png" alt="" onClick={download}/> */}
                                    <Button
                                        icon={<img src="/icon/upload.svg" style={{ width: 15, height: 15, marginRight: 6, transform: 'rotate(180deg)' }} />}
                                        size={'medium'}
                                        onClick={download}
                                        style={{
                                            color: "white",
                                            background: "#377A47",
                                            border: "black",
                                            fontSize: 13,
                                            borderRadius: 7,
                                            marginRight: 10,
                                        }}
                                    >
                                        Download Excel
                                    </Button>
                                </Row>
                            </Col>
                            <Col span={isMedia || isContact || isTranslate ? 12 : 24}>
                                <Row justify="end">
                                    <Col
                                        xs={0}
                                        sm={0}
                                        md={isMedia || isContact || isTranslate ? 24 : 12}
                                        lg={isMedia || isContact || isTranslate ? 20 : 9}
                                        xl={isMedia || isContact || isTranslate ? 15 : 7}
                                        xxl={isMedia || isContact || isTranslate ? 10 : 6}
                                    >
                                        <Form.Item
                                            name="Search"
                                            label="Search"
                                            style={{ marginRight: isMedia || isContact || isTranslate ? 0 : 25 }}
                                        >
                                            <Input
                                                className="input-search"
                                                onChange={(e) =>
                                                    setSearchValue(
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </Form.Item>
                                    </Col>
                                    {!isHiddenAction ? (
                                        <Link to={`${link}add`}>
                                            <Button
                                                icon={<PlusCircleOutlined />}
                                                style={{
                                                    color: "white",
                                                    background: "#67c23a",
                                                    border: "black",
                                                    fontSize: 15,
                                                    borderRadius: 7,
                                                    display: isMedia ? "none" : 'block'
                                                }}
                                            >
                                                Create {title}
                                            </Button>
                                        </Link>
                                    ) : (
                                        ""
                                    )}
                                </Row>
                            </Col>
                        </Row>
                    ) : (
                        ""
                    )}
                </PageHeader>
            </Col>
        </Row>
    );
};

export default Register;
